var map = {
	"./evoting-no-weight.json": 601,
	"./evoting.json": 602
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 600;



//////////////////
// WEBPACK FOOTER
// ./client/components/schemas ^\.\/.*\.json$
// module id = 600
// module chunks = 0